// components/Dashboard.js
import React from "react";
// import {
//   Building,
//   FileText,
//   Briefcase,
//   Users,
//   BarChart2,
//   DollarSign
// } from 'react-feather';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const Dashboard = ({ user }) => {
  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-12">
          <h1 className="h2">Dashboard</h1>
          <p className="text-muted">Welcome to your company dashboard</p>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-3 mb-4">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title">Company Profile</h5>
                  <p className="card-text">Complete: 80%</p>
                </div>
                {/* <Building size={36} /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-4">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title">Blog Posts</h5>
                  <p className="card-text">5 Published</p>
                </div>
                {/* <FileText size={36} /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-4">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title">Job Postings</h5>
                  <p className="card-text">3 Active</p>
                </div>
                {/* <Briefcase size={36} /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-4">
          <div className="card bg-warning text-dark">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="card-title">Profile Views</h5>
                  <p className="card-text">124 This Month</p>
                </div>
                {/* <Users size={36} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Monthly Stats</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-around text-center my-4">
                <div>
                  {/* <BarChart2 size={24} className="text-primary mb-2" /> */}
                  <h4>124</h4>
                  <p className="text-muted">Profile Views</p>
                </div>
                <div>
                  {/* <Users size={24} className="text-success mb-2" /> */}
                  <h4>24</h4>
                  <p className="text-muted">Job Applicants</p>
                </div>
                <div>
                  {/* <DollarSign size={24} className="text-info mb-2" /> */}
                  <h4>8</h4>
                  <p className="text-muted">Inquiries</p>
                </div>
              </div>
              <div className="bg-light p-3 rounded">
                <p className="mb-0 text-center">
                  <strong>Tip:</strong> Complete your company profile to get
                  more visibility
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Quick Actions</h5>
            </div>
            <div className="card-body">
              <div className="d-grid gap-2">
                <button className="btn btn-outline-primary">
                  {/* <Building size={18} className="me-2" /> */}
                  Edit Company Profile
                </button>
                <button className="btn btn-outline-success">
                  {/* <FileText size={18} className="me-2" /> */}
                  Add Blog Post
                </button>
                <button className="btn btn-outline-info">
                  {/* <Briefcase size={18} className="me-2" /> */}
                  Post a Job
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
